export default __webpack_public_path__ + "static/earth_normal_2048-4757980b7fc36ed41ca5c2d2b62140a7.jpg";